let development_url = "http://127.0.0.1:7100";
let production_url = "http://bjbapi.hbsjykxyjy.cn";
// let production_url = 'http://bjapi.king90.com';

export default {
  serviceAddress: process.env.NODE_ENV === "development" ? development_url : production_url,
  wpsAppId:
    process.env.NODE_ENV !== "development" && production_url.indexOf("hbsjykxyjy") > -1
      ? "AK20260401ZJGUWA"
      : "SX20240407JUZBZA",
  appKey: process.env.NODE_ENV !== "development" && production_url.indexOf("hbsjykxyjy") != -1 ? "edit" : "edittest",
};
